import { CaseData, MedicalCoverageType, PartyModel, YearInfoModel } from "@/types/case";
import { lookupDataService } from "@/services/lookupDataService";
import { getCalcRuntimeContext } from './calcRuntimeContext';
import { SchoolDistrictLookup } from './types';



export function getPetitionerParty(caseData: CaseData): PartyModel | null {
    if (caseData?.representation?.petitionerParty === "partyA") {
        return caseData?.parties?.partyA!;
    } else if (caseData?.representation?.petitionerParty === "partyB") {
        return caseData?.parties?.partyB!;
    } else {
        // should never get here; validations should have caught this.
        return null;
        // throw new Error(`Getting petitionerParty: value of '${caseData.representation.petitionerParty}' in caseData.representation.petitionerParty must be either 'partyA' or 'partyB' to run calculations. check validation function.`);
    }
}

export function getRespondentParty(caseData: CaseData): PartyModel | null {
    if (caseData?.representation?.petitionerParty === "partyB") {
        return caseData?.parties?.partyA!;
    } else if (caseData?.representation?.petitionerParty === "partyA") {
        return caseData?.parties?.partyB!;
    } else {
        // should never get here; validations should have caught this.
        return null;
        // throw new Error(`Getting respondentParty: value of '${caseData.representation.petitionerParty}' in caseData.representation.petitionerParty must be either 'partyA' or 'partyB' to run calculations. check validation function.`);
    }
}

export function roundTo(input: number, places: number = 2) {
    const shiftBy = Math.pow(10, places);
    const temp = input * shiftBy;
    const rv = Math.round(temp) / shiftBy;
    return rv;
}

export function sumBy<T>(
    items: T[],
    selector: (item: T) => number
): number {
    return items.reduce((sum, item) => sum + selector(item), 0);
}

export function avgBy<T>(
    items: T[],
    selector: (item: T) => number
): number {
    if (items.length === 0) {
        return 0;
    }
    return sumBy(items, selector) / items.length;
}

export function getYearInfo(schedule: string, oddIfAlternating: boolean, party: PartyModel | null): YearInfoModel | null {
    if (schedule === 'alternating') {
        if (oddIfAlternating) {
            return party?.tax?.claimSchedule?.odd ?? null;
        } else {
            return party?.tax?.claimSchedule?.even ?? null;
        }
    } else {
        return party?.tax?.claimSchedule?.all ?? null;
    }
}


export function getSchoolDistrictSurtaxRate(schoolDistrictId: string): number {
    const ctx = getCalcRuntimeContext();
    if (ctx?.environment === 'server' && ctx.consolidatedLookups?.lookups) {
        const rows = ctx.consolidatedLookups.lookups['schoolDistrictLookup'] as unknown as SchoolDistrictLookup[] | undefined;
        if (rows?.length) {
            const schoolDistrict = rows.find(x => x.id === schoolDistrictId);
            return schoolDistrict?.surtaxRate ?? 0.0;
        }
        return 0.0;
    }

    const rv = lookupDataService.getLookupDataByTableSync('school_district_lookup') as SchoolDistrictLookup[] | null;
    if (!!rv) {
        const schoolDistrict = rv.find(x => x.id === schoolDistrictId);
        return schoolDistrict?.surtaxRate ?? 0.0;
    }
    return 0.0;
}

export function isCustodialParent(caseData: CaseData, party: PartyModel | null): boolean {
    return caseData.children.custodyArrangement === 'partyA' && caseData.parties.partyA === party ||
        caseData.children.custodyArrangement === 'partyB' && caseData.parties.partyB === party;
}

export function isNoncustodialParent(caseData: CaseData, party: PartyModel | null): boolean {
    return caseData.children.custodyArrangement === 'partyA' && caseData.parties.partyB === party ||
        caseData.children.custodyArrangement === 'partyB' && caseData.parties.partyA === party;
}

export function isSharedParent(caseData: CaseData): boolean {
    return caseData.children.custodyArrangement === 'shared';
}

export function isSplitParent(caseData: CaseData): boolean {
    return caseData.children.custodyArrangement === 'split';
}



export function convertMedicalCoverageTypeToLabel(coverageTypeId: string | undefined | null): string {
    switch (coverageTypeId) {
        case 'noCost':
            return 'No Cost Insurance';
        case 'privatePay':
            return 'Private Pay';
        case 'hawkI':
            return 'HAWK-I';
        case 'titleXIX':
            return 'Title XIX';
        case 'none':
            return 'No Insurance';
        default:
            return coverageTypeId ?? '';
    }
}